import { makeStyles } from '@material-ui/styles';
// import tinycolor from 'tinycolor2';

export default makeStyles(theme => ({
    st0: {
        fill: '#000082',
    },

    st2: {
        fill: '#010134',
    },

    st11: {
        fill: 'none',
    },

    st12: {
        fill: '#FFFFFF',
    },

    st13: {
    },

    st14: {
        fontSize: '16px',
        fontWeight: '500',
    },

}));
